/**
 * Local copy of Zephr’s content-cliff CSS (from the production footer zone).
 * Zephr also injects this in a <style> tag; we keep it colocated so it unmounts
 * with the stand-in. `position: fixed` is implied by Zephr’s base zone CSS,
 * which is not loaded on CSK localhost.
 */
export const ZEPHR_CLIFF_STAND_IN_CSS = `
:root {
  --csk-zephr-font: var(--font-polysans, system-ui, sans-serif);
  --csk-zephr-cta-font: var(--font-polysans-mono, ui-monospace, monospace);
}

#zephr-overlay {
  position: fixed;
  inset: 0;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.45);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.5s;
}

#zephr-overlay.visible {
  opacity: 1;
  pointer-events: auto;
}

#zephr-zone-footer {
  position: fixed;
  left: 0;
  right: 0;
  width: 100%;
  bottom: -100vh;
  z-index: 100000;
}

#zephr-zone-footer.transform {
  transition: translate 0.3s;
  translate: 0 -100vh;
}

#zephr-footer-container {
  background-color: #3cffd0;
  color: #000;
  padding: 16px;
  justify-content: center;
  align-items: center;
  font-family: var(--csk-zephr-font);
  left: 0;
  right: 0;
}

#zephr-footer-body {
  background-color: #3cffd0;
  color: #000;
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

#zephr-footer-body > div {
  margin: 10px;
}

#zephr-footer-body button {
  background-color: #5200ff;
  border: 0 solid #5200ff;
  border-radius: 2px;
  color: #fff;
  width: 100%;
  padding: 13px 20px;
  line-height: 20px;
  font-size: 12px;
  font-weight: 500;
  font-family: var(--csk-zephr-cta-font);
  letter-spacing: 1.44px;
  margin-bottom: 16px;
}

#zephr-footer-body-title {
  font-weight: 600;
  font-size: 28px;
  line-height: 104%;
  letter-spacing: -0.32px;
  margin-bottom: 12px;
}

#zephr-footer-body-subheading {
  font-size: 18px;
  line-height: 120%;
  max-width: 700px;
}

#zephr-footer-body-section-1,
#zephr-footer-body-section-2 {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}

#zephr-footer-body-section-2 {
  font-weight: 600;
  width: 100%;
}

#zephr-footer-bottom {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.zephr-footer-text {
  text-transform: uppercase;
  font-weight: 400;
  letter-spacing: 1.1px;
  line-height: 18px;
  font-size: 11px;
}

#zephr-link-divider {
  display: none;
  height: 20px;
  border-left: 1px solid rgba(0, 0, 0, 0.3);
  margin: 0 10px;
}

.zephr-link {
  cursor: pointer;
  text-decoration: none;
  border-bottom: 1px solid black;
}

@media (min-width: 767px) {
  #zephr-footer-container {
    padding: 20px;
  }

  #zephr-footer-body {
    padding: 24px 20px;
  }

  #zephr-footer-body-title {
    font-size: 34px;
    line-height: 90%;
    letter-spacing: -0.4px;
    margin-bottom: 16px;
  }

  #zephr-footer-body-subheading {
    font-size: 20px;
    line-height: 28px;
  }

  #zephr-footer-body button {
    width: 290px;
    padding: 13px 48px;
    margin-bottom: 20px;
  }

  #zephr-footer-bottom {
    flex-direction: row;
    line-height: 28px;
    font-size: 12px;
  }

  #zephr-link-divider {
    display: flex;
  }
}
`;
